export interface IMaterial {
    id: number;
    name: string;
    isbn: string;
    isbn10: string;
    author: string;
    edition: string;
    publisher: string;
    discountId: string;
    weight: string;
    length: string;
    width: string;
    copyright: string;
    custom: string;
    nationalISBN: string;
    avalibleQuantity: number;
}

const newMaterial = (): IMaterial => ({
    id: 0,
    name: '',
    isbn: '',
    isbn10: '',
    author: '',
    edition: '',
    publisher: '',
    discountId: '',
    weight: '',
    length: '',
    width: '',
    copyright: '',
    custom: '',
    nationalISBN: '',
    avalibleQuantity: 0,
})

export const createMaterial = <T extends Partial<IMaterial>>(initialValues: T): IMaterial & T => {
    return Object.assign(newMaterial(), initialValues);
};